import React,{ useState, useEffect , useRef, useMemo } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from '../components/ConfirmationDialogRaw';
import { downloadCsv } from '../common/sharedFunctions';
import MaterialTable from "material-table";
import TableIcons from '../components/TableIcons';
import { tableOptions } from '../components/TableDefaults';
import {
  Grid,
  Typography,
  Modal,
  Button,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Box,
  TextField,
  InputAdornment,
  Chip,
  Menu,
  IconButton,
  Tooltip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import GoogleMapsAutoComplete from '../components/GoogleMapsAutoComplete';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { useNavigate } from 'react-router-dom';
import { api } from 'common';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import UsersCombo from '../components/UsersCombo';
import { makeStyles } from '@mui/styles';
import { useTranslation } from "react-i18next";
import CancelIcon from '@mui/icons-material/Cancel';
import AlertDialog from '../components/AlertDialog';
import { BidModal } from 'common/sharedFunctions';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PlaceIcon from '@mui/icons-material/Place';
import PersonIcon from '@mui/icons-material/Person';
import { acceptBid } from 'common/sharedFunctions';
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 680,
    maxWidth: '95vw',
    backgroundColor: '#FFFFFF',
    border: 'none',
    boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
    padding: theme.spacing(3),
    borderRadius: 16,
  },
  action: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    height: 40,
    borderRadius: 12,
    paddingLeft: 12,
    paddingRight: 12,
    fontWeight: 600,
  }
}));

const icons = {
  'paypal':require('../assets/payment-icons/paypal-logo.png').default,
  'braintree':require('../assets/payment-icons/braintree-logo.png').default,
  'stripe':require('../assets/payment-icons/stripe-logo.png').default,
  'paytm':require('../assets/payment-icons/paytm-logo.png').default,
  'payulatam':require('../assets/payment-icons/payulatam-logo.png').default,
  'flutterwave':require('../assets/payment-icons/flutterwave-logo.png').default,
  'paystack':require('../assets/payment-icons/paystack-logo.png').default,
  'securepay':require('../assets/payment-icons/securepay-logo.png').default,
  'payfast':require('../assets/payment-icons/payfast-logo.png').default,
  'liqpay':require('../assets/payment-icons/liqpay-logo.png').default,
  'culqi':require('../assets/payment-icons/culqi-logo.png').default,
  'mercadopago':require('../assets/payment-icons/mercadopago-logo.png').default,
  'squareup':require('../assets/payment-icons/squareup-logo.png').default,
  'wipay':require('../assets/payment-icons/wipay-logo.png').default,
  'test':require('../assets/payment-icons/test-logo.png').default,
  'razorpay':require('../assets/payment-icons/razorpay-logo.png').default,
}

const BookingHistory = (props) => {
  const { t, i18n  } = useTranslation();
  const isRTL = i18n.dir();
  const {
    cancelBooking,
    updateBooking,
    RequestPushMsg,
    updateWalletBalance
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const userdata = useSelector(state => state.usersdata);
  const settings = useSelector(state => state.settingsdata.settings);
  const cartypes = useSelector(state => state.cartypes.cars);
  const role = useSelector(state => state.auth.profile.usertype);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const providers = useSelector(state => state.paymentmethods.providers);
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [data, setData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState();
  const bookinglistdata = useSelector(state => state.bookinglistdata);
  const [users, setUsers] = useState(null);
  const [userCombo, setUserCombo] = useState(null);
  const rootRef = useRef(null);
  const [open,setOpen] = useState(false);
  const [rowIndex,setRowIndex] = useState();
  const [forceAccept, setForceAccept] = useState(false);
  const [bidModalStatus, setBidModalStatus] = useState();
  const [selectedBidder, setSelectedBidder] = useState();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const classes = useStyles();
  const navigate = useNavigate();

  // Custom 5-column definition
  const columns = [
    {
      title: t('booking'),
      field: 'id',
      render: rowData => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              bgcolor: '#EEF2FF',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <LocalTaxiIcon sx={{ fontSize: 20, color: '#6366F1' }} />
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>
              #{rowData.id?.substring(0, 8) || 'N/A'}
            </Typography>
            <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
              {rowData.tripdate ? new Date(rowData.tripdate).toLocaleDateString() : '-'}
            </Typography>
          </Box>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
    },
    {
      title: t('customer'),
      field: 'customer_name',
      render: rowData => (
        <Box>
          <Typography sx={{ fontWeight: 500, fontSize: 14, color: '#111827' }}>
            {rowData.customer_name || t('guest')}
          </Typography>
          <Typography sx={{ fontSize: 12, color: '#6B7280' }}>
            {settings?.AllowCriticalEditsAdmin ? rowData.customer_contact : '***'}
          </Typography>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
    },
    {
      title: t('route'),
      field: 'pickupAddress',
      render: rowData => (
        <Box sx={{ maxWidth: 200 }}>
          <Typography sx={{ fontSize: 13, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {rowData.pickupAddress?.substring(0, 25) || '-'}...
          </Typography>
          <Typography sx={{ fontSize: 12, color: '#6B7280', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            → {rowData.dropAddress?.substring(0, 25) || '-'}...
          </Typography>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
    },
    {
      title: t('amount'),
      field: 'trip_cost',
      render: rowData => (
        <Typography sx={{ fontWeight: 600, fontSize: 14, color: '#111827' }}>
          {settings?.symbol || ''}{rowData.selectedBid?.trip_cost || rowData.trip_cost || '0'}
        </Typography>
      ),
      cellStyle: { padding: '12px 16px' },
    },
    {
      title: t('status'),
      field: 'status',
      render: rowData => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <FiberManualRecordIcon sx={{ fontSize: 10, color: getStatusColor(rowData.status) }} />
          <Typography sx={{ fontSize: 13, color: '#374151', fontWeight: 500 }}>
            {rowData.status || '-'}
          </Typography>
        </Box>
      ),
      cellStyle: { padding: '12px 16px' },
    },
  ];
  const active = useSelector(state => state.bookinglistdata.active);
  const computedActive = useMemo(()=>{
    if(!bookinglistdata || !Array.isArray(bookinglistdata.bookings)) return [];
    const statuses = ['PAYMENT_PENDING','NEW','ACCEPTED','ARRIVED','STARTED','REACHED','PENDING','PAID'];
    return bookinglistdata.bookings.filter(b=> statuses.includes(b.status));
  },[bookinglistdata]);
  const [walletModalStatus, setWalletModalStatus] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [editPickup, setEditPickup] = useState(null);
  const [editDrop, setEditDrop] = useState(null);
  const [editCarType, setEditCarType] = useState('');
  const [editDateTime, setEditDateTime] = useState('');
  const [editContactName, setEditContactName] = useState('');
  const [editContactPhone, setEditContactPhone] = useState('');
  const [editContactEmail, setEditContactEmail] = useState('');
  const [editNote, setEditNote] = useState('');

  useEffect(()=>{
        if(bookinglistdata.bookings){
            setData(bookinglistdata.bookings);
        }else{
          setData([]);
        }
  },[bookinglistdata.bookings]);

  useEffect(() => {
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'driver' && ((user.fleetadmin === auth.profile.uid && role === 'fleetadmin')|| role === 'admin')) {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden"),
            'pushToken': user.pushToken,
            'carType':user.carType
          });
        }
      }
      setUsers(arr);
    }
  }, [userdata.users,settings.AllowCriticalEditsAdmin,auth.profile.uid,role]);

  const assignDriver = () => {
    let booking = data[rowIndex];
    if(!userCombo){ return; }

    if(forceAccept){
      // Force accept: populate driver fields and set status to ACCEPTED
      const full = (userdata.users||[]).find(u=>u.id===userCombo.uid) || {};
      const curBooking = { ...booking };
      curBooking.status = 'ACCEPTED';
      curBooking.driver = userCombo.uid;
      curBooking.driver_image = full.profile_image || '';
      curBooking.car_image = full.car_image || '';
      curBooking.driver_name = `${userCombo.firstName||''} ${userCombo.lastName||''}`.trim();
      curBooking.driver_contact = userCombo.mobile || full.mobile || '';
      curBooking.driver_token = userCombo.pushToken || full.pushToken || '';
      curBooking.vehicle_number = full.vehicleNumber || '';
      curBooking.driverRating = full.rating || '0';
      curBooking.requestedDrivers = null;
      curBooking.driverEstimates = null;
      dispatch(updateBooking(curBooking));
      // Notify customer that a driver has been assigned
      if(curBooking.customer_token){
        RequestPushMsg(curBooking.customer_token, {
          title: t('notification_title'),
          msg: t('driver_assigned') || 'Driver assigned to your trip',
          screen: 'BookedCab',
          params: { bookingId: curBooking.id }
        });
      }
      // Notify driver they have been assigned
      RequestPushMsg(
        userCombo.pushToken,
        { title: t('notification_title'), msg: t('new_booking_notification'), screen: 'DriverTrips', channelId: settings.CarHornRepeat? 'bookings-repeat': 'bookings' }
      );
    } else {
      // Normal assign: add to requestedDrivers
      if(booking['requestedDrivers']){
        booking['requestedDrivers'][userCombo.uid]=true;
      }else{
        booking['requestedDrivers']={};
        booking['requestedDrivers'][userCombo.uid]=true;
      }
      dispatch(updateBooking(booking));
      RequestPushMsg(
        userCombo.pushToken, 
        { 
          title: t('notification_title'), 
          msg: t('new_booking_notification'),
          screen: 'DriverTrips',
          channelId: settings.CarHornRepeat? 'bookings-repeat': 'bookings'
        }
      );
    }
    setForceAccept(false);
    setUserCombo(null);
    handleClose();
    alert(t('driver_assigned_success') || 'Driver assigned successfully.');
  }

  const onConfirmClose=(value)=>{
    if(value){
      dispatch(cancelBooking({
        reason:value,
        booking:selectedBooking,
        cancelledBy: role
      }));
    }
    setOpenConfirm(false);
  }

  const handleChange = (e) => {
    if(e.target.name === 'selectedProviderIndex'){
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    }
    if(e.target.name === 'selectedBidder'){
      setSelectedBidder(e.target.value);
    }
  };

  const openEditModal = (rowData) => {
    const idx = rowData.tableData.id;
    setEditIndex(idx);
    setSelectedBooking(rowData);
    // initialize editable fields from booking
    if (rowData.pickup) {
      setEditPickup({ description: rowData.pickup.add, coords: { lat: rowData.pickup.lat, lng: rowData.pickup.lng } });
    }
    if (rowData.drop) {
      setEditDrop({ description: rowData.drop.add, coords: { lat: rowData.drop.lat, lng: rowData.drop.lng } });
    }
    setEditCarType(rowData.carType || '');
    if (rowData.bookLater && rowData.tripdate) {
      try {
        const d = new Date(rowData.tripdate);
        const tzoffset = d.getTimezoneOffset() * 60000;
        const localISOTime = new Date(d - tzoffset).toISOString().slice(0,16);
        setEditDateTime(localISOTime);
      } catch(e){ setEditDateTime(''); }
    } else {
      setEditDateTime('');
    }
    setEditContactName(rowData.customer_name || '');
    setEditContactPhone(rowData.customer_contact || '');
    setEditContactEmail(rowData.customer_email || '');
    setEditNote(rowData.tripInstructions || '');
    setEditOpen(true);
  };

  const saveEdit = () => {
    if (editIndex == null) return setEditOpen(false);
    const cur = { ...data[editIndex] };
    if (editPickup && editPickup.coords) {
      cur.pickup = { lat: editPickup.coords.lat, lng: editPickup.coords.lng, add: editPickup.description };
      cur.pickupAddress = editPickup.description;
    }
    if (editDrop && editDrop.coords) {
      cur.drop = { lat: editDrop.coords.lat, lng: editDrop.coords.lng, add: editDrop.description };
      cur.dropAddress = editDrop.description;
    }
    if (editCarType) cur.carType = editCarType;
    if (selectedBooking && selectedBooking.bookLater && editDateTime) {
      cur.tripdate = new Date(editDateTime).getTime();
    }
    // Contact info and note
    cur.customer_name = editContactName || cur.customer_name || '';
    cur.customer_contact = editContactPhone || cur.customer_contact || '';
    cur.customer_email = editContactEmail || cur.customer_email || '';
    cur.tripInstructions = editNote || null;
    // Clear pending driver requests since route/type may change
    cur.requestedDrivers = null;
    cur.driverEstimates = null;
    dispatch(updateBooking(cur));
    setEditOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  }

  const handlePaymentModalClose = (e) => {
      setTimeout(()=>{
        setPaymentModalStatus(false);
      },1500)
  }

  const handleWalletModalClose = (e) => {
    setTimeout(()=>{
      setWalletModalStatus(false);
    },1500);
  }

  useEffect(()=>{
    if(providers){
      setSelectedProvider(providers[0]);
    }
  },[providers]);

  const processPayment = (rowData) =>{
    const curBooking = rowData;

    if(curBooking.payment_mode ==='card'){
      let paymentCost = (curBooking.selectedBid? curBooking.selectedBid.trip_cost: curBooking.trip_cost);
      const paymentPacket = { 
        payment_mode: 'card',
        customer_paid: parseFloat(paymentCost).toFixed(settings.decimal),
        cardPaymentAmount: parseFloat(paymentCost).toFixed(settings.decimal),
        discount: 0,
        usedWalletMoney:0,
        cashPaymentAmount: 0,
        promo_applied: false,
        promo_details: null,
        payableAmount: parseFloat(paymentCost).toFixed(settings.decimal),
      };
      curBooking.paymentPacket = paymentPacket;
      dispatch(updateBooking(curBooking));
      setSelectedBooking(curBooking);
      setPaymentModalStatus(true);
    }
    if(curBooking.payment_mode ==='wallet'){
      let curBooking = { ...rowData };
      if(rowData.status === "PAYMENT_PENDING"){
        curBooking.status = 'NEW';
        curBooking.prepaid = true;
      } else if(rowData.status === "PENDING"){
        curBooking.status = 'PAID';
      }else if(rowData.status === "NEW"){
        curBooking.prepaid = true;
        curBooking.status = 'ACCEPTED';
      }

      curBooking.customer_paid =  curBooking.status === 'ACCEPTED'? 0: parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = curBooking.status === 'ACCEPTED'? 0: parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = curBooking.status === 'ACCEPTED'?parseFloat(curBooking.selectedBid.trip_cost).toFixed(settings.decimal):parseFloat(curBooking.trip_cost).toFixed(settings.decimal);

      if(curBooking.status === 'ACCEPTED'){
        curBooking.driver = curBooking.selectedBid.driver;
        curBooking.driver_image =  curBooking.selectedBid.driver_image; 
        curBooking.driver_name = curBooking.selectedBid.driver_name;
        curBooking.driver_contact = curBooking.selectedBid.driver_contact;
        curBooking.driver_token = curBooking.selectedBid.driver_token;
        curBooking.vehicle_number = curBooking.selectedBid.vehicle_number;
        curBooking.driverRating = curBooking.selectedBid.driverRating;
        curBooking.trip_cost =  curBooking.selectedBid.trip_cost;
        curBooking.convenience_fees =  curBooking.selectedBid.convenience_fees;
        curBooking.driver_share =  curBooking.selectedBid.driver_share;
        curBooking.driverOffers = {};
        curBooking.requestedDrivers = {};
        curBooking.driverEstimates = {};
        curBooking.selectedBid = {};
      } 
      dispatch(updateBooking(curBooking));

      let walletBal = parseFloat(auth.profile.walletBalance) - parseFloat(curBooking.trip_cost);
      let tDate = new Date();
      let details = {
        type: 'Debit',
        amount: curBooking.trip_cost,
        date: tDate.getTime(),
        txRef: curBooking.id
      }
      dispatch(updateWalletBalance(walletBal,details));

      
      setBidModalStatus(false);
    }
    if(curBooking.payment_mode ==='cash'){
        let curBooking = { ...rowData };
        if(rowData.status === "PAYMENT_PENDING"){
          curBooking.status = 'NEW';
        } else if(rowData.status === "PENDING"){
          curBooking.status = 'PAID';
        }else if(rowData.status === "NEW"){
          curBooking.status = 'ACCEPTED';
        }

        curBooking.customer_paid =  curBooking.status === 'ACCEPTED'? 0: parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
        curBooking.discount = 0;
        curBooking.usedWalletMoney = 0;
        curBooking.cardPaymentAmount = 0;
        curBooking.cashPaymentAmount = curBooking.status === 'ACCEPTED'? 0: parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
        curBooking.payableAmount = curBooking.status === 'ACCEPTED'?parseFloat(curBooking.selectedBid.trip_cost).toFixed(settings.decimal):parseFloat(curBooking.trip_cost).toFixed(settings.decimal);
  
        if(curBooking.status === 'ACCEPTED'){
          curBooking.driver = curBooking.selectedBid.driver;
          curBooking.driver_image =  curBooking.selectedBid.driver_image; 
          curBooking.driver_name = curBooking.selectedBid.driver_name;
          curBooking.driver_contact = curBooking.selectedBid.driver_contact;
          curBooking.driver_token = curBooking.selectedBid.driver_token;
          curBooking.vehicle_number = curBooking.selectedBid.vehicle_number;
          curBooking.driverRating = curBooking.selectedBid.driverRating;
          curBooking.trip_cost =  curBooking.selectedBid.trip_cost;
          curBooking.convenience_fees =  curBooking.selectedBid.convenience_fees;
          curBooking.driver_share =  curBooking.selectedBid.driver_share;
          curBooking.driverOffers = {};
          curBooking.requestedDrivers = {};
          curBooking.driverEstimates = {};
          curBooking.selectedBid = {};
        } 
        dispatch(updateBooking(curBooking));
        setBidModalStatus(false);
    }
  }

  const handleWalletPayment = (e) => {
    e.preventDefault();
    let curBooking = { ...selectedBooking };
    let paymentCost = (curBooking.selectedBid? curBooking.selectedBid.trip_cost: curBooking.trip_cost);
    if(parseFloat(paymentCost)>parseFloat(auth.profile.walletBalance)){
      setCommonAlert({open:true, msg: t('wallet_balance_low')});
    }else{
      curBooking.prepaid = curBooking.status === 'NEW' || curBooking.status === 'PAYMENT_PENDING'? true: false;
      curBooking.status = (curBooking.status === 'NEW'? 'ACCEPTED' : 'PAID');
      curBooking.customer_paid = parseFloat(paymentCost).toFixed(settings.decimal);
      curBooking.discount = 0;
      curBooking.usedWalletMoney = parseFloat(paymentCost).toFixed(settings.decimal);
      curBooking.cardPaymentAmount = 0;
      curBooking.cashPaymentAmount = 0;
      curBooking.payableAmount = 0;
      curBooking.promo_applied = false;
      curBooking.promo_details = null;
      curBooking.paymentPacket = null;
      curBooking.driver =  (curBooking.selectedBid? curBooking.selectedBid.driver: curBooking.driver); 
      curBooking.driver_image =  (curBooking.selectedBid? curBooking.selectedBid.driver_image: curBooking.driver_image); 
      curBooking.driver_name = ( curBooking.selectedBid? curBooking.selectedBid.driver_name: curBooking.driver_name); 
      curBooking.driver_contact =( curBooking.selectedBid? curBooking.selectedBid.driver_contact: curBooking.driver_contact); 
      curBooking.driver_token = ( curBooking.selectedBid? curBooking.selectedBid.driver_token: curBooking.driver_token); 
      curBooking.vehicle_number = ( curBooking.selectedBid? curBooking.selectedBid.vehicle_number: curBooking.vehicle_number); 
      curBooking.driverRating = ( curBooking.selectedBid? curBooking.selectedBid.driverRating: curBooking.driverRating); 
      curBooking.trip_cost =  ( curBooking.selectedBid? curBooking.selectedBid.trip_cost: curBooking.trip_cost); 
      curBooking.convenience_fees =  ( curBooking.selectedBid? curBooking.selectedBid.convenience_fees: curBooking.convenience_fees); 
      curBooking.driver_share =   (curBooking.selectedBid? curBooking.selectedBid.driver_share: curBooking.driver_share); 
      curBooking.driverOffers = null;
      curBooking.requestedDrivers = null;
      curBooking.driverEstimates = null;
      curBooking.selectedBid = null;
  
      dispatch(updateBooking(curBooking));

      let walletBal = parseFloat(auth.profile.walletBalance) - parseFloat(curBooking.trip_cost);
      let tDate = new Date();
      let details = {
        type: 'Debit',
        amount: curBooking.trip_cost,
        date: tDate.getTime(),
        txRef: curBooking.id
      }
      dispatch(updateWalletBalance(walletBal,details));

      setTimeout(()=>{
        setWalletModalStatus(false);
      },1500);     
    }
  }

  const handleBidModalClose = () => {
    setBidModalStatus(false);
  }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [statusAnchor, setStatusAnchor] = useState(null);

  // Filtered data
  const filteredData = useMemo(() => {
    let result = data;
    if (filterStatus !== 'all') {
      result = result.filter(d => d.status === filterStatus);
    }
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      result = result.filter(d =>
        (d.id && d.id.toLowerCase().includes(query)) ||
        (d.customer_name && d.customer_name.toLowerCase().includes(query)) ||
        (d.driver_name && d.driver_name.toLowerCase().includes(query)) ||
        (d.pickupAddress && d.pickupAddress.toLowerCase().includes(query)) ||
        (d.dropAddress && d.dropAddress.toLowerCase().includes(query))
      );
    }
    return result;
  }, [data, filterStatus, searchQuery]);

  const clearFilters = () => {
    setFilterStatus('all');
    setSearchQuery('');
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'NEW': case 'PAYMENT_PENDING': return '#3B82F6';
      case 'ACCEPTED': case 'ARRIVED': case 'STARTED': return '#10B981';
      case 'REACHED': case 'PENDING': case 'PAID': return '#8B5CF6';
      case 'COMPLETE': return '#10B981';
      case 'CANCELLED': return '#EF4444';
      default: return '#6B7280';
    }
  };

  const getStatusLabel = () => {
    if (filterStatus === 'all') return t('status') || 'Status';
    return filterStatus;
  };

  return (
    bookinglistdata.loading? <CircularLoading/>:
    <div>
      <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb:2, flexWrap:'wrap', gap:1 }}>
        <Typography variant="h5" sx={{ fontWeight: 700 }}>{t('my_bookings') || 'My bookings'}</Typography>
        <Box sx={{ display:'flex', gap:1 }}>
          <Button variant="contained" color="primary" onClick={()=>navigate('/addbookings')}>
            {t('book_a_ride') || 'Book a ride'}
          </Button>
          <Button variant="outlined" onClick={()=>navigate('/userwallet')}>
            {t('wallet') || 'Wallet'}
          </Button>
        </Box>
      </Box>
    {(active && active.length>0) || (computedActive.length>0) ? (
      <Box sx={{ p:2, mb:2, borderRadius:2, bgcolor:'#f8f8f8', border:'1px solid #dedede' }}>
        <Typography variant="subtitle1" sx={{ fontWeight:700 }}>{t('active_trip') || 'Active trip'}</Typography>
        <Typography variant="body2" sx={{ opacity:0.9 }}>{t('active_trip_hint') || 'You have a trip in progress. Tap to view details.'}</Typography>
        <Button sx={{ mt:1 }} variant="contained" onClick={()=>window.scrollTo({top:0, behavior:'smooth'})}>{t('view_details') || 'View details'}</Button>
      </Box>
    ) : null}
    {(!data || data.length===0) ? (
      <Box sx={{ textAlign:'center', py:8, color:'#727272', bgcolor:'#fff', borderRadius:2 }}>
        <EventAvailableIcon sx={{ fontSize: 48, color:'#a2a2a2' }}/>
        <Typography variant="h6" sx={{ mt:1 }}>{t('no_bookings_yet') || 'No bookings yet'}</Typography>
        <Typography variant="body2" sx={{ opacity:0.8, mt:0.5 }}>{t('no_bookings_help') || 'Start by creating your first booking.'}</Typography>
        <Button sx={{ mt:2 }} variant="contained" onClick={()=>navigate('/addbookings')}>{t('book_a_ride') || 'Book a ride'}</Button>
      </Box>
    ) : (
    <>
      {/* Uber-Style Filter Toolbar */}
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1.5,
          p: 2,
          mb: 2,
          bgcolor: '#FFFFFF',
          borderRadius: 3,
          border: '1px solid #E5E7EB',
          alignItems: 'center',
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
        }}
      >
        <TextField
          size="small"
          placeholder={t('search') || 'Search bookings...'}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          sx={{
            minWidth: 220,
            '& .MuiOutlinedInput-root': {
              borderRadius: 50,
              bgcolor: '#F7F7F7',
              '& fieldset': { border: 'none' },
              '&:hover': { bgcolor: '#EFEFEF' },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: '#6B7280', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
        <Box sx={{ width: 1, height: 24, bgcolor: '#E5E7EB', mx: 1 }} />
        <Chip
          label={t('all') || 'All'}
          onClick={clearFilters}
          sx={{
            bgcolor: filterStatus === 'all' ? '#111827' : '#F7F7F7',
            color: filterStatus === 'all' ? '#FFFFFF' : '#374151',
            fontWeight: 500,
            fontSize: 13,
            height: 36,
            borderRadius: 50,
            px: 1,
            cursor: 'pointer',
            '&:hover': { bgcolor: filterStatus === 'all' ? '#000000' : '#EFEFEF' },
          }}
        />
        <Chip
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              {filterStatus !== 'all' && (
                <FiberManualRecordIcon sx={{ fontSize: 8, color: getStatusColor(filterStatus) }} />
              )}
              {getStatusLabel()}
              <ExpandMoreIcon sx={{ fontSize: 16, ml: 0.5 }} />
            </Box>
          }
          onClick={(e) => setStatusAnchor(e.currentTarget)}
          sx={{
            bgcolor: filterStatus !== 'all' ? '#111827' : '#F7F7F7',
            color: filterStatus !== 'all' ? '#FFFFFF' : '#374151',
            fontWeight: 500,
            fontSize: 13,
            height: 36,
            borderRadius: 50,
            px: 1,
            cursor: 'pointer',
            '&:hover': { bgcolor: filterStatus !== 'all' ? '#000000' : '#EFEFEF' },
          }}
        />
        <Menu
          anchorEl={statusAnchor}
          open={Boolean(statusAnchor)}
          onClose={() => setStatusAnchor(null)}
          PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 180, boxShadow: '0 4px 20px rgba(0,0,0,0.15)' } }}
        >
          <MenuItem onClick={() => { setFilterStatus('all'); setStatusAnchor(null); }}>
            <Typography sx={{ fontSize: 14 }}>{t('all') || 'All'}</Typography>
          </MenuItem>
          {['NEW', 'ACCEPTED', 'STARTED', 'PENDING', 'PAID', 'COMPLETE', 'CANCELLED'].map(status => (
            <MenuItem key={status} onClick={() => { setFilterStatus(status); setStatusAnchor(null); }}>
              <FiberManualRecordIcon sx={{ fontSize: 10, color: getStatusColor(status), mr: 1 }} />
              <Typography sx={{ fontSize: 14 }}>{status}</Typography>
            </MenuItem>
          ))}
        </Menu>
        <Typography sx={{ ml: 'auto', fontSize: 13, color: '#6B7280' }}>
          {filteredData.length} {t('booking_title') || 'bookings'}
        </Typography>
      </Box>

    <MaterialTable
      icons={TableIcons}
      title={null}
      style={{
        direction: isRTL === 'rtl' ? 'rtl' : 'ltr',
        borderRadius: 12,
        boxShadow: 'none',
        border: '1px solid #E5E7EB',
        overflow: 'hidden',
      }}
      columns={columns}
      data={filteredData}
      onRowClick={((evt, selectedRow) => setSelectedRow(selectedRow.tableData.id))}
      detailPanel={rowData => (
        <Box sx={{ p: 3, bgcolor: '#F9FAFB', borderTop: '1px solid #E5E7EB' }}>
          <Grid container spacing={3}>
            {/* Trip Details */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <PlaceIcon sx={{ fontSize: 18, color: '#6366F1' }} />
                <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                  {t('trip_details') || 'Trip Details'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('booking_id')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827', fontWeight: 500 }}>{rowData.id || '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('booking_date')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.bookingDate ? new Date(rowData.bookingDate).toLocaleString() : '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('trip_date')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.tripdate ? new Date(rowData.tripdate).toLocaleString() : '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('car_type')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.carType || '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('pickup_address')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827', maxWidth: 200, textAlign: 'right' }}>{rowData.pickupAddress || '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('drop_address')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827', maxWidth: 200, textAlign: 'right' }}>{rowData.dropAddress || '-'}</Typography>
                </Box>
              </Box>
            </Grid>

            {/* Payment Details */}
            <Grid item xs={12} md={6}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <AttachMoneyIcon sx={{ fontSize: 18, color: '#16A34A' }} />
                <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                  {t('payment_details') || 'Payment Details'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('trip_cost')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827', fontWeight: 600 }}>{settings?.symbol}{rowData.trip_cost || '0'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('payment_mode')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.payment_mode || '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('distance')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.distance ? `${rowData.distance} km` : '-'}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('discount')}</Typography>
                  <Typography sx={{ fontSize: 13, color: '#111827' }}>{settings?.symbol}{rowData.discount || '0'}</Typography>
                </Box>
              </Box>
            </Grid>

            {/* Driver Info */}
            {rowData.driver_name && (
              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                  <PersonIcon sx={{ fontSize: 18, color: '#2563EB' }} />
                  <Typography sx={{ fontWeight: 600, fontSize: 15, color: '#111827' }}>
                    {t('driver_info') || 'Driver Info'}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('driver_name')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.driver_name || '-'}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontSize: 13, color: '#6B7280' }}>{t('vehicle_number')}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#111827' }}>{rowData.vehicle_number || '-'}</Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {/* Actions */}
            <Grid item xs={12}>
              <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                {(rowData.status === 'NEW' || rowData.status === 'ACCEPTED') && (
                  <Tooltip title={t('cancel_booking')}>
                    <IconButton
                      onClick={() => {
                        if (settings.AllowCriticalEditsAdmin) {
                          setSelectedBooking(rowData);
                          setOpenConfirm(true);
                        } else {
                          alert(t('demo_mode'));
                        }
                      }}
                      sx={{ bgcolor: '#FEE2E2', '&:hover': { bgcolor: '#FECACA' } }}
                    >
                      <CancelIcon sx={{ fontSize: 18, color: '#DC2626' }} />
                    </IconButton>
                  </Tooltip>
                )}
                {rowData.status === 'NEW' && (role === 'admin' || role === 'fleetadmin') && (
                  <Tooltip title={t('assign_driver')}>
                    <IconButton
                      onClick={() => { setOpen(true); setRowIndex(rowData.tableData.id); }}
                      sx={{ bgcolor: '#DBEAFE', '&:hover': { bgcolor: '#BFDBFE' } }}
                    >
                      <PersonAddIcon sx={{ fontSize: 18, color: '#2563EB' }} />
                    </IconButton>
                  </Tooltip>
                )}
                {['NEW', 'PAYMENT_PENDING'].includes(rowData.status) && (role === 'admin' || role === 'fleetadmin') && (
                  <Tooltip title={t('edit_booking') || 'Edit booking'}>
                    <IconButton
                      onClick={() => openEditModal(rowData)}
                      sx={{ bgcolor: '#F3F4F6', '&:hover': { bgcolor: '#E5E7EB' } }}
                    >
                      <EditIcon sx={{ fontSize: 18, color: '#374151' }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
      options={{
        ...tableOptions,
        search: false,
        toolbar: false,
        showTitle: false,
        exportCsv: (columns, data) => {
          let hArray = [];
          const headerRow = columns.map(col => {
            if (typeof col.title === 'object') {
              return col.title.props.text;
            }
            hArray.push(col.field);
            return col.title;
          });
          const dataRows = data.map(({ tableData, ...row }) => {
            row.bookingDate = new Date(row.bookingDate).toLocaleDateString() + ' '+ new Date(row.bookingDate).toLocaleTimeString()
            row.tripdate = new Date(row.tripdate).toLocaleDateString() + ' '+ new Date(row.tripdate).toLocaleTimeString();
            row.pickupAddress = row.pickupAddress.replace(/,/g, ";");
            row.dropAddress = row.dropAddress.replace(/,/g, ";");
            let dArr = [];
            for(let i=0;i< hArray.length; i++) {
              dArr.push(row[hArray[i]]);
            }
            return Object.values(dArr);
          })
          const { exportDelimiter } = ",";
          const delimiter = exportDelimiter ? exportDelimiter : ",";
          const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
          const csvFileName = 'download.csv';
          downloadCsv(csvContent, csvFileName);
        },
        exportButton: {
          csv: settings.AllowCriticalEditsAdmin,
          pdf: false,
        },
        maxColumnSort: "all_columns",
        rowStyle: rowData => ({
          backgroundColor: (selectedRow === rowData.tableData.id) ? '#F3F4F6' : '#fff'
        }),
      }}
      localization={{
        toolbar: {
          searchPlaceholder: (t('search')),
          exportTitle: (t('export')),
          exportCSVName: (t('export')),
        },
        header: {
          actions: (t('actions')) 
        },
        pagination: {
          labelDisplayedRows: ('{from}-{to} '+ (t('of'))+ ' {count}'),
          //labelRowsSelect: (t('rows')),
          firstTooltip: (t('first_page_tooltip')),
          previousTooltip: (t('previous_page_tooltip')),
          nextTooltip: (t('next_page_tooltip')),
          lastTooltip: (t('last_page_tooltip'))
        },
      }}
      />
    </>
    )}

    <BidModal
      ref = {rootRef.current} 
      role = {role}
      selectedBooking = {selectedBooking}
      bidModalStatus ={bidModalStatus}
      handleBidModalClose = {handleBidModalClose}
      classes = {classes}
      settings = {settings}
      acceptBid = {()=>{ 
        const bookingObj = acceptBid(selectedBooking, selectedBidder)
        processPayment(bookingObj);
        handleBidModalClose();
      }}
      selectedBidder = {selectedBidder}
      handleChange = {handleChange}
    />
  {selectedBooking && selectedBooking.payment_mode === 'wallet' && (selectedBooking.status ==='PENDING' || (selectedBooking && selectedBooking.selectedBid && selectedBooking.status ==='NEW')) && role==='customer'?
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={walletModalStatus}
        onClose={handleWalletModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
            <Typography  style={{fontWeight:'bolder', marginBottom:10}}>
              {t('payment')}
            </Typography>
            {selectedBooking?
            <Typography color={"primary"} style={{fontSize:30}}>
              { (settings.swipe_symbol===false? settings.symbol + selectedBooking.trip_cost :  selectedBooking.trip_cost + settings.symbol) }
            </Typography>
            :null}
            <Typography >
              {t('use_wallet_balance') + " " + (settings.swipe_symbol===false? settings.symbol + auth.profile.walletBalance :  auth.profile.walletBalance + settings.symbol) + ")"}
            </Typography>
          </Grid>            
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handleWalletModalClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" style={{marginLeft:10}} onClick={handleWalletPayment}>
              {t('paynow_button')}
            </Button>
          </Grid>
        </Grid>
      </Modal>
      :null}
    {/* Edit booking modal for admin/fleetadmin */}
    {editOpen && selectedBooking && (role==='admin' || role==='fleetadmin') ? (
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={editOpen}
        onClose={()=>setEditOpen(false)}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper} style={{direction:isRTL==='rtl'?'rtl':'ltr'}}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography component="h1" variant="h5" className={classes.title} style={{textAlign:isRTL=== 'rtl' ? 'right' : 'left'}}>
                {t('edit_booking') || 'Edit booking'}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <GoogleMapsAutoComplete
                variant="outlined"
                placeholder={t('pickup_location') || 'Pickup location'}
                value={editPickup}
                className={classes.items}
                onChange={(value)=>setEditPickup(value)}
              />
            </Grid>
            <Grid item xs={12}>
              <GoogleMapsAutoComplete
                variant="outlined"
                placeholder={t('drop_location') || 'Dropoff location'}
                value={editDrop}
                className={classes.items}
                onChange={(value)=>setEditDrop(value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormLabel component="legend">{t('car_type') || 'Car type'}</FormLabel>
              <Select fullWidth variant="outlined" value={editCarType} onChange={(e)=>setEditCarType(e.target.value)}>
                {cartypes && cartypes.sort((a,b)=>a.pos-b.pos).map((c)=>(
                  <MenuItem key={c.name} value={c.name}>{c.name}</MenuItem>
                ))}
              </Select>
            </Grid>
            {selectedBooking.bookLater ? (
              <Grid item xs={12} sm={6}>
                <FormLabel component="legend">{t('booking_date_time') || 'Booking date & time'}</FormLabel>
                <input type="datetime-local" value={editDateTime} onChange={(e)=>setEditDateTime(e.target.value)} style={{width:'100%', height: 48, padding: '10px', boxSizing:'border-box'}} />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={6}>
              <TextField
                label={t('contact_name') || 'Contact name'}
                variant="outlined"
                fullWidth
                value={editContactName}
                onChange={(e)=>setEditContactName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={t('contact_phone') || 'Contact phone'}
                variant="outlined"
                fullWidth
                value={editContactPhone}
                onChange={(e)=>setEditContactPhone(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label={t('contact_email') || 'Contact email'}
                variant="outlined"
                fullWidth
                value={editContactEmail}
                onChange={(e)=>setEditContactEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={t('note_to_driver') || 'Note to driver'}
                variant="outlined"
                fullWidth
                multiline
                minRows={2}
                value={editNote}
                onChange={(e)=>setEditNote(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} style={{textAlign:isRTL==='rtl'?'right':'left'}}>
              <Button onClick={()=>setEditOpen(false)} variant="contained" color="primary">{t('cancel') || 'Cancel'}</Button>
              <Button onClick={saveEdit} variant="contained" color="primary" style={ isRTL=== 'rtl' ? {marginRight:10} : {marginLeft:10}}>
                {t('save') || 'Save'}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>
    ) : null}
      {selectedBooking && selectedBooking.paymentPacket && selectedBooking.payment_mode === 'card' && (selectedBooking.status ==='PENDING' || (selectedBooking && selectedBooking.selectedBid && selectedBooking.status ==='NEW')) && role==='customer'?
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
          {providers && selectedProvider && selectedBooking?
          <form action={selectedProvider.link} method="POST">
            <input type='hidden' name='order_id' value={selectedBooking.id}/>
            <input type='hidden' name='amount' value={selectedBooking.trip_cost}/>
            <input type='hidden' name='currency' value={settings.code}/>
            <input type='hidden' name='product_name' value={t('bookingPayment')}/>
            <input type='hidden' name='first_name' value={auth.profile.firstName}/>
            <input type='hidden' name='last_name' value={auth.profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={selectedBooking.customer}/>
            <input type='hidden' name='mobile_no' value={selectedBooking.customer_contact}/>
            <input type='hidden' name='email' value={selectedBooking.customer_email}/>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{marginBottom: '20px'}}>
              <FormControl fullWidth>
              <FormLabel component="legend">{t('payment')}</FormLabel>
              <Select
                  id="selectedProviderIndex"
                  name= "selectedProviderIndex"
                  value={selectedProviderIndex}
                  label={t('payment')}
                  onChange={handleChange}
                  style={{textAlign:isRTL==='rtl'? 'right':'left'}}
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  {providers.map((provider,index) =>
                    <MenuItem key={provider.name} value={index}><img style={{height:24,margin:7}} src={icons[provider.name]} alt={provider.name}/> </MenuItem>
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handlePaymentModalClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" type="submit" style={{marginLeft:10}} onClick={handlePaymentModalClose}>
              {t('paynow_button')}
            </Button>
            </Grid>
          </form>
          :null}
        </Grid>
      </Modal>
      :null}
    <ConfirmationDialogRaw
      open={openConfirm}
      onClose={onConfirmClose}
      value={''}
    />
    {users && data && rowIndex>=0?
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        onClose={handleClose}
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <Typography component="h1" variant="h5" className={classes.title} style={{textAlign:isRTL=== 'rtl' ? 'right' : 'left'}}>
                {t('select_driver')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
                <UsersCombo
                  className={classes.items}
                  placeholder={t('select_user')}
                  users={users.filter(usr => usr.carType === data[rowIndex].carType)}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <FormLabel component="legend">{t('force_accept_now') || 'Force accept now'}</FormLabel>
                <Select
                  variant="outlined"
                  value={forceAccept? 'yes':'no'}
                  onChange={(e)=> setForceAccept(e.target.value==='yes')}
                >
                  <MenuItem value='no'>{t('no') || 'No'}</MenuItem>
                  <MenuItem value='yes'>{t('yes') || 'Yes'}</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} style={{direction: isRTL=== 'rtl' ?'rtl' : 'ltr', marginLeft:isRTL=== 'rtl' ? '65%' : 0}}>
            <Button onClick={handleClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button onClick={assignDriver} variant="contained" color="primary" style={ isRTL=== 'rtl' ? {marginRight:10} : {marginLeft:10}}>
              {t('assign')}
            </Button>
          </Grid>
          </Grid>
        </div>
      </Modal>
      :null}
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
    </div>

  );
}

export default BookingHistory;
